import { render } from "./ChipCard.vue?vue&type=template&id=7bb635d0&scoped=true"
import script from "./ChipCard.vue?vue&type=script&lang=js"
export * from "./ChipCard.vue?vue&type=script&lang=js"

import "./ChipCard.vue?vue&type=style&index=0&id=7bb635d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb635d0"]])

export default __exports__